export class UniqueId {
    private idCounter: number = 0;

    next(): string {
        return "$" + ++this.idCounter;
    }
}
